import React, { Component } from "react";

export default class ViewportFix extends Component {
	
	constructor(){
		super();
		this.handleResize = this.handleResize.bind(this);
		this.state={
			width:0,
			height:0,
		}
  	}
  	
  	componentDidMount() {
	  	window.addEventListener('resize', this.handleResize);
	  	this.handleResize();
	  	setTimeout(() => {
		  	this.handleResize();
	  	}, 400);
  	}
  	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
  	
  	handleResize() {
	  	let screenWidth = window.innerWidth;
	  	let screenHeight = window.innerHeight;
	  	let htmlElement = document.documentElement;
	  	let isTouchDevice = htmlElement.classList.contains('state-touch');

	  	const setViewportHeight = (height) => {
			let vh = height * 0.01;
			htmlElement.style.setProperty('--vh', `${vh}px`);
		};

	  	let rvh = screenHeight * 0.01;
	  	htmlElement.style.setProperty('--rvh', `${rvh}px`);

	  	if (isTouchDevice) {
		  	if (this.state.height === 0) {
			  	setViewportHeight(screenHeight);
			  	this.setState({width: screenWidth, height: screenHeight});
		  	} else if (screenWidth !== this.state.width && this.state.height > screenHeight) {
			  	setViewportHeight(screenHeight);
			  	this.setState({width: screenWidth, height: screenHeight});
		  	} else {
			  	setViewportHeight(this.state.height);
		  	}
	  	} else {
		  	setViewportHeight(screenHeight);
		  	this.setState({width: screenWidth, height: screenHeight});
	  	}
  	}
  	
  	render () {
	  	
  		return <div></div>;
	
	}
}